import { FileText, LoaderCircle } from 'lucide-react';

import styles from './DocumentCard.module.css';

interface DocumentCardProps {
  title: string;
  details: ReadonlyArray<string>;
  /** PDF shown as the thumbnail; null shows a placeholder icon. */
  previewUrl: string | null;
  previewLoading?: boolean;
  ariaLabel: string;
  onSelect(): void;
}

/** A page-thumbnail card for a document in a patient list. */
export function DocumentCard({
  title,
  details,
  previewUrl,
  previewLoading = false,
  ariaLabel,
  onSelect,
}: DocumentCardProps) {
  return (
    <button type="button" className={styles.card} onClick={onSelect} aria-label={ariaLabel}>
      {previewLoading ? (
        <div className={styles.thumbnailFallback} aria-label="Loading preview">
          <LoaderCircle className="size-5 animate-spin" aria-hidden="true" />
        </div>
      ) : previewUrl === null ? (
        <div className={styles.thumbnailFallback} aria-hidden="true">
          <FileText />
        </div>
      ) : (
        <div className={styles.thumbnail}>
          <iframe
            src={`${previewUrl}#page=1&toolbar=0&navpanes=0&zoom=page-fit`}
            title={`${title} preview`}
            className={styles.documentFrame}
            loading="lazy"
          />
          <span className={styles.thumbnailLabel}>Page 1</span>
        </div>
      )}
      <span className={styles.footer}>
        <span className={styles.title}>{title}</span>
        {details.map((detail) => (
          <span key={detail} className={styles.detail}>
            {detail}
          </span>
        ))}
      </span>
    </button>
  );
}
